<template>
  <!--  单选表单 -->
  <div>
    <h4>{{ index }}. {{ question.question }}</h4>
    <van-radio-group v-if="question.optionType==='single'" v-model="result" direction="horizontal" icon-size="24px" @change="handleChange">
      <van-radio v-for="(item, indexs) in question.options" :key="indexs" :name="item">{{ item }}</van-radio>
    </van-radio-group>
    <van-cell-group v-if="question.optionType==='input'">
      <van-field v-model="value" placeholder="单行输入" type="number" @blur="getInput">
        <template #right-icon>°c</template>
      </van-field>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: 'RadioForm',
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      result: '',
      value: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleChange(answer) {
      this.$emit('change', { id: this.question.id, answer, question: this.question.question })
    },
    getInput() {
      const data = {
        id: this.question.id,
        question: this.question.question,
        answer: this.value
      }
      this.$emit('change', data)
    }
  }
}
</script>

<style lang="less" scoped>
h4 {
  font-size: 16px;
  color: #000000;
  font-weight: 500;
}
</style>
